const settings = {
  title: 'Settings',
  profile: 'Profile',
  signOut: 'Sign Out',
  saved: 'Settings saved',
  errorSaving: 'Error saving settings',

  versionInfo: 'Version info',
  versionInfoDescription: 'Support may ask for these numbers when debugging.',
  nativeVersion: 'Native version',
  bundleVersion: 'Bundle version',
  buildNumber: 'Build number',
  unknown: 'Unknown',

  appSettings: 'App Settings',
  transcriptionSettings: 'Transcription Settings',

  changeLanguage: 'Change Language',
  context: 'Hard to understand terms for AI',
  contextPlaceholder: 'Xanax, Prilosec, Amoxicillin Clavulanate Potassium, ...',
  specialization: 'Specialization',
  specializationPlaceholder: 'cardiology, endocrinology, ...',
  clinic: 'Clinic',
  clinicPlaceholder: 'general practice, cardiology, ...',
  customTemplates: 'Custom Templates',
  contactUsDescription:
    'For custom document templates and software integrations, contact us at ',
  contactUsButton: 'Contact Us',

  subscription: {
    title: 'Subscription',
    used: 'Used {{count}} of {{max}} free reports this month.',
    subscribedPrefix: 'You are subscribed to the ',
    subscribedSuffix: ' plan.',
    manage: 'Manage Subscription',
    manageSubscriptionError: 'Could not open subscription management.',
    subscribe: 'Subscribe',
    restorePurchase: 'Restore Purchases',
    restoringPurchases: 'Restoring purchases...',
    purchasesRestoredSuccessfully: 'Purchases restored successfully',
    noPurchasesFound: 'No purchases found',
    privacyPolicy: 'Privacy Policy',
    termsOfService: 'Terms of Use',
    packages: {
      $rc_monthly: 'Monthly Pro ({{price}})',
      $rc_annual: 'Annual Pro ({{price}})',
    },
  },
};

export default settings;
